module.exports = __webpack_public_path__ + "media/images/instruction/step-three-975c1ccc9cfc5ef99b0237f069f5d914.svg";